<template>
  <!--
    ClosingCta — the Home_Page closing call-to-action directing the Visitor to
    the Contact_Page (Requirement 4.5). Copy and the CTA target come from the
    structured Home content module.
  -->
  <section class="closing-cta" aria-labelledby="closing-cta-heading">
    <v-container>
      <ScrollReveal tag="div" class="closing-cta__inner">
        <h2 id="closing-cta-heading" class="closing-cta__heading">
          {{ closingCta.heading }}
        </h2>
        <p v-if="closingCta.body" class="closing-cta__body">
          {{ closingCta.body }}
        </p>
        <div class="closing-cta__action">
          <CtaButton
            v-if="closingCta.cta"
            :label="closingCta.cta.label"
            :to="closingCta.cta.to"
          />
        </div>
      </ScrollReveal>
    </v-container>
  </section>
</template>

<script>
// ClosingCta — Home_Page closing CTA to the Contact_Page (Requirement 4.5).
import CtaButton from 'components/CtaButton.vue'
import ScrollReveal from 'components/ScrollReveal.vue'
import home from 'src/content/home'

export default {
  name: 'ClosingCta',
  components: { CtaButton, ScrollReveal },
  data () {
    return {
      closingCta: home.closingCta
    }
  }
}
</script>

<style scoped>
.closing-cta {
  padding: 88px 0;
  background: linear-gradient(135deg, #41281b 0%, #e7511e 100%);
  color: #fff;
}

.closing-cta__inner {
  text-align: center;
  max-width: 640px;
  margin: 0 auto;
}

.closing-cta__heading {
  font-size: clamp(1.9rem, 4vw, 2.8rem);
  font-weight: 800;
  margin-bottom: 16px;
}

.closing-cta__body {
  font-size: 1.15rem;
  line-height: 1.6;
  margin-bottom: 32px;
  opacity: 0.95;
}

.closing-cta__action {
  display: flex;
  justify-content: center;
}
</style>
